import styled, { css } from 'styled-components';

export const SelectContainer = styled.div`
	position: relative;
	margin: 0;
	width: 100%;
`;

export const SelectLabelButton = styled.button`
	font-family: ${({ theme }) => theme.typography.fontSecondary};

	padding: 10px 20px;
	min-width: 200px;
	width: 100%;
	font-size: 14px;
	font-weight: 500;
	background-color: transparent;
	border: 1px solid ${({ theme }) => theme.palette.brand.main};
	border-radius: var(--r-pill);
	color: ${({ theme }) => theme.palette.text.main};
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.palette.brand.main};
		color: ${({ theme }) => theme.palette.black};
	}
`;

export const DropdownStyle = styled.div<{ $visible: boolean }>`
	position: absolute;
	top: 0;
	left: 0;
	max-height: 200px;
	width: 100%;
	min-width: 10rem;
	padding: 0.4rem;
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.palette.surface.minimal};
	transition: max-height 0.2s ease;
	overflow: scroll;
	${(p) =>
		!p.$visible &&
		css`
			max-height: 40px;
			visibility: hidden;
		`}
`;

export const DropdownItem = styled.div<{ $active: boolean }>`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 10px 20px;
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.palette.text.main};
	cursor: pointer;
	border-radius: var(--r-card);
	${(p) =>
		p.$active &&
		css`
			font-weight: 500;
		`}
	&:hover,
  :focus,
  :focus:hover {
		background-color: ${({ theme }) => theme.palette.brand.main};
		color: ${({ theme }) => theme.palette.black};
	}
`;
